import moment from 'moment';
import {
  ADD_REPORT,
  SET_EXPENSE_RESULTS,
  MOVE_EXPENSE,
  SUBMIT_EXPENSE,
  DELETE_EXPENSE,
  UPDATE_EXPENSE,
  ADD_EXPENSE,
  UPDATE_MILIAGE,
  UPDATE_LAST_POSITION,
  SET_EXPENSE_CATEGORIES,
  SET_EXPENSE_DISTANCE_RATES,
  SET_EXPENSE_ATTENDEES,
  SET_CURRENCY_LIST,
  SET_CREDIT_CARDS_LIST,
  SET_CURRENT_REPORT_ID_FOR_UPDATE,
  SET_CURRENT_SELECTED_SUBCATEGORY_FOR_MANUAL_TAB,
  SET_CURRENT_RECEIPTS_OF_USER,
  SET_RECEIPTS_STATE,
  SET_CURRENT_EXPENSE_REPORT_CARD_MODAL_ITEM,
  SET_LOST_RECEIPT,
  SET_EXPENSE_VALUE,
  INITIATE_EXPENSE_VALUES,
  SET_MULTIPLE_EXPENSE_VALUES,
  SET_SHOULD_FETCH_CHARGES,
  SET_SELECTED_CHARGES_QUEUE,
  CLEAR_SELECTED_CHARGES_QUEUE,
} from '../actions/expense';
import {
  EXPENSE_ACTION_TYPES,
  EXPENSE_SUB_TAB_OPTIONS,
  LOST_RECEIPT_OPTION,
} from '../../constants/Enums';
import { assignReceiptId, removeLostReceipt } from '../../utils/common.utils';
import { DynamoDBFieldNames } from '../../constants/ExpenseCategories';

const { RECEIPTS, CHARGES, MILEAGE, MANUAL, ANY } = EXPENSE_SUB_TAB_OPTIONS;

// Helper function to update manuallyUpdatedFields
const updateManuallyUpdatedFields = ({ currentState, key }) => {
  if (!currentState.manuallyUpdatedFields.includes(key)) {
    return [...currentState.manuallyUpdatedFields, key];
  }
  return currentState.manuallyUpdatedFields;
};

const initialState = {
  miliage: 0,
  lastPosition: null,
  expenseNumber: 1000000,
  receiptData: null,
  [EXPENSE_ACTION_TYPES.CREATION]: {
    [RECEIPTS]: {},
    [CHARGES]: {},
    [MILEAGE]: {},
    [MANUAL]: {},
  },
  [EXPENSE_ACTION_TYPES.UPDATE]: {
    [ANY]: {},
  },
  shouldFetchCharges: false,
  selectedChargesQueue: [],
  list: [
    // {
    //   reportId: '0',
    //   status: 'pending',
    //   reportName: 'Steves Expense 1000001',
    //   number: 1000001,
    //   count: 1,
    //   cost: 175.14,
    //   startDate: '2020-08-01',
    //   endDate: '2020-08-01',
    //   receipt: 'jsmith@company.com',
    //   message: 'Food expenses for september',
    //   items: [
    //     {
    //       id: '0A',
    //       merchant: 'Main Street Restaurant',
    //       cost: 32.0,
    //       number: '123456',
    //       date: '2020-08-01',
    //       image: '',
    //     },
    //   ],
    // },
    // {
    //   reportId: '1',
    //   status: 'pending',
    //   reportName: 'Steves Expense 1000002',
    //   number: 1000002,
    //   cost: 325.45,
    //   count: 1,
    //   startDate: '2020-09-10',
    //   endDate: '2020-09-10',
    //   receipt: 'jsmith@company.com',
    //   message: 'Food expenses for september',
    //   items: [
    //     {
    //       id: '0B',
    //       merchant: 'Second Street Restaurant',
    //       cost: 36.0,
    //       number: '6543',
    //       date: '2020-09-10',
    //       image: '',
    //     },
    //   ],
    // },
    // {
    //   reportId: '2',
    //   status: 'submitted',
    //   reportName: 'Steves Expense 1000003',
    //   number: 1000003,
    //   count: 1,
    //   cost: 215.45,
    //   startDate: '2020-07-12',
    //   endDate: '2020-07-12',
    //   receipt: 'jsmith@company.com',
    //   message: 'Food expenses for september',
    //   items: [
    //     {
    //       id: '0D',
    //       merchant: 'Main Street Restaurant',
    //       cost: 32.0,
    //       number: '123456',
    //       date: '2020-07-12',
    //       image: '',
    //     },
    //   ],
    // },
  ],
};

const createNewExpense = (report, expenses) => {
  const startDate = expenses[0]?.date || null;
  const endDate = expenses[expenses.length - 1]?.date || null;

  return {
    ...report,
    expenses,
    cost: expenses.reduce((acum, i) => acum + Number(i.cost), 0),
    count: expenses.length,
    startDate,
    endDate,
  };
};

const addExpense = (report, expense) => {
  const newItems = report.expenses.slice();
  newItems.push(expense);
  newItems.sort((a, b) => moment(a.date).valueOf() - moment(b.date).valueOf());
  return createNewExpense(report, newItems);
};

const removeExpense = (report, index) => {
  const newItems = report.expenses.slice();
  newItems.splice(index, 1);
  return createNewExpense(report, newItems);
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_EXPENSE_RESULTS:
      return {
        ...state,
        list: JSON.parse(action.list),
      };
    case ADD_REPORT:
      return {
        expenseNumber: state.expenseNumber + 1,
        list: [action.report, ...state.list],
      };
    case ADD_EXPENSE:
      return {
        ...state,
        list: state.list.map((item) => {
          if (item.reportId === action.reportId) {
            return addExpense(item, action.expense);
          }
          return item;
        }),
      };
    case UPDATE_EXPENSE:
      return {
        ...state,
        list: state.list.map((item) => {
          if (item.reportId === action.reportId) {
            return {
              ...item,
              [action.key]: action.value,
            };
          }
          return item;
        }),
      };
    case MOVE_EXPENSE:
      return {
        ...state,
        list: state.list.map((item) => {
          if (item.reportId === action.originId) {
            return removeExpense(item, action.index);
          } else if (item.reportId === action.destinationId) {
            return addExpense(item, action.expense);
          }
          return item;
        }),
      };
    case DELETE_EXPENSE: {
      return {
        ...state,
        list: state.list.map((item) => {
          if (item.reportId === action.reportId) {
            return removeExpense(item, action.index);
          }
          return item;
        }),
      };
    }
    case SUBMIT_EXPENSE:
      return {
        ...state,
        list: state.list.map((item) => {
          if (item.reportId === action.reportId) {
            return {
              ...item,
              status: 'submitted',
            };
          }
          return item;
        }),
      };
    case UPDATE_MILIAGE:
      return {
        ...state,
        miliage: action.miliage,
        lastPosition: action.lastPosition,
      };
    case UPDATE_LAST_POSITION:
      return {
        ...state,
        lastPosition: action.lastPosition,
      };
    case SET_EXPENSE_CATEGORIES:
      return {
        ...state,
        expenseCategories: action.expenseCategories,
      };
    case SET_EXPENSE_DISTANCE_RATES:
      return {
        ...state,
        distanceRates: action.distanceRates,
      };
    case SET_EXPENSE_ATTENDEES:
      return {
        ...state,
        attendees: action.attendees,
      };
    case SET_CURRENCY_LIST:
      return {
        ...state,
        currencies: action.currencies,
      };
    case SET_CREDIT_CARDS_LIST:
      return {
        ...state,
        creditCards: action.creditCards,
      };
    case SET_CURRENT_REPORT_ID_FOR_UPDATE:
      return {
        ...state,
        currentReportIdForUpdate: action.reportId,
      };
    case SET_CURRENT_SELECTED_SUBCATEGORY_FOR_MANUAL_TAB:
      return {
        ...state,
        currentSelectedSubCategoryForManualTab: action.subCategory,
      };
    case SET_CURRENT_RECEIPTS_OF_USER:
      return {
        ...state,
        receiptsOfCurrentUser: action.receipts,
      };
    case SET_RECEIPTS_STATE: {
      const { actionType, subTab, receipts } = action;
      return {
        ...state,
        [actionType]: {
          ...state[actionType],
          [subTab]: {
            ...state[actionType][subTab],
            receipts: assignReceiptId(removeLostReceipt(receipts)),
            manuallyUpdatedFields: updateManuallyUpdatedFields({
              currentState: state[actionType][subTab],
              key: DynamoDBFieldNames.RECEIPTS,
            }),
          },
        },
      };
    }
    case SET_LOST_RECEIPT: {
      const { actionType, subTab } = action;
      return {
        ...state,
        [actionType]: {
          ...state[actionType],
          [subTab]: {
            ...state[actionType][subTab],
            receipts: [LOST_RECEIPT_OPTION],
          },
        },
      };
    }
    case SET_CURRENT_EXPENSE_REPORT_CARD_MODAL_ITEM:
      return {
        ...state,
        currentExpenseReportCardModalItem: action.item,
      };
    case INITIATE_EXPENSE_VALUES: {
      const { actionType, subTab, formFields } = action.payload; // formFields is an object of { stateName: initial value }
      return {
        ...state,
        [actionType]: {
          ...state[actionType],
          [subTab]: formFields,
        }, // Update the actionType state with the modified properties
      };
    }
    case SET_EXPENSE_VALUE: {
      const { actionType, subTab, key, value } = action.payload;
      return {
        ...state,
        [actionType]: {
          ...state[actionType],
          [subTab]: {
            ...state[actionType][subTab],
            [key]: value,
            manuallyUpdatedFields: updateManuallyUpdatedFields({
              currentState: state[actionType][subTab],
              key,
            }),
          },
        },
      };
    }
    case SET_MULTIPLE_EXPENSE_VALUES: {
      const { actionType, subTab, updatedFields } = action.payload;
      return {
        ...state,
        [actionType]: {
          ...state[actionType],
          [subTab]: {
            ...state[actionType][subTab],
            ...updatedFields,
          },
        },
      };
    }
    case SET_SHOULD_FETCH_CHARGES: {
      return {
        ...state,
        shouldFetchCharges: action.shouldFetchCharges,
      };
    }
    case SET_SELECTED_CHARGES_QUEUE:
      return {
        ...state,
        selectedChargesQueue: action.charges,
      };
    case CLEAR_SELECTED_CHARGES_QUEUE:
      return {
        ...state,
        selectedChargesQueue: [],
      };
    default:
      return state;
  }
};
